import { HeartIcon as HeartFilledIcon } from '@heroicons/react/24/solid';
import { HeartIcon as HeartOutlineIcon } from '@heroicons/react/24/outline';
import { useAppDispatch, useAppSelector } from '../../stores/store.ts';
import { selectAccountFavoriteByName } from '../account/favorite/accountFavoritesSelectors.ts';
import apiNet from '../../newApi/apiNet.ts';
import { FavoriteTypeEnum } from '../../types/account/favoriteTypeTypes.ts';
import { accountFavoritesActions } from '../account/favorite/accountFavoritesSlice.ts';
import { ButtonSize } from '../../types/button.ts';

interface IProps {
    name: string;
    type: FavoriteTypeEnum;
    size?: ButtonSize;
}

const FavoriteButton = ({ name, type, size = ButtonSize.BASE }: IProps) => {
    const favorite = useAppSelector(selectAccountFavoriteByName(name));
    const isFavorite = !!favorite;
    const _dispatch = useAppDispatch();

    const handleToggleFavorite = async () => {
        try {
            if (isFavorite) {
                await apiNet.deleteFavorite(favorite.id);
                _dispatch(accountFavoritesActions.removeFavorite(favorite.id));
            } else {
                const result = await apiNet.addFavorite({ name, type, searchQuery: name.toLowerCase() });
                _dispatch(accountFavoritesActions.addFavorite({ name, type, id: result.data.id }));
            }
        } catch (e) {

        }
    };

    const getSizeClass = () => {
        let sizeClass = '';
        switch (size) {
            case ButtonSize.SMALL:
                sizeClass = 'w-6 h-6';
                break;
            case ButtonSize.BASE:
                sizeClass = 'w-7 h-7';
                break;
            case ButtonSize.LARGE:
                sizeClass = 'w-8 h-8';
                break;
        }

        return sizeClass;
    };

    const getPaddingClass = () => {
        let sizeClass = '';
        switch (size) {
            case ButtonSize.SMALL:
                sizeClass = 'p-1.5';
                break;
            case ButtonSize.BASE:
                sizeClass = 'p-1.5';
                break;
            case ButtonSize.LARGE:
                sizeClass = 'p-2.5';
                break;
        }

        return sizeClass;
    };

    return (
        <button
            className={`border border-neutral-500 rounded-full bg-neutral-600 hover:bg-neutral-500 transition ${getPaddingClass()}`}
            onClick={async () => {
                await handleToggleFavorite();
            }}>
            {isFavorite ?
                <HeartFilledIcon className={`${getSizeClass()}`} /> :
                <HeartOutlineIcon className={`${getSizeClass()}`} />
            }
        </button>
    );
};

export default FavoriteButton;